import React from 'react';
import { useLocation } from 'react-router-dom';

import { PATH_SCREEN_MAP, ScreenKey } from 'constant/ScreenPermission';
import Forbidden from 'pages/error/Forbidden';

type Props = {
  allowedScreens: ScreenKey[];
  children: React.ReactNode;
};

/**
 * URL直打ち防止ガード
 * 現在のパス末尾からScreenKeyを判定し、allowedScreensに含まれなければForbiddenを表示する。
 */
const ScreenGuard: React.FC<Props> = ({ allowedScreens, children }) => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);
  const lastSegment = segments[segments.length - 1] || '';

  const screenKey = PATH_SCREEN_MAP[lastSegment];

  if (screenKey && !allowedScreens.includes(screenKey)) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

export default ScreenGuard;
